var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReferenceMultipleSelect',{staticClass:"ma-0",attrs:{"label":"Страна отправления","resource":"countries"},on:{"input":_vm.changeSendingCountries},model:{value:(_vm.sendingCountries),callback:function ($$v) {_vm.sendingCountries=$$v},expression:"sendingCountries"}})
}
var staticRenderFns = []

export { render, staticRenderFns }